# ------------------------------------*|
#     #Editor Layout -> insertSpace
# ------------------------------------*|


moduleInsertSpace = angular.module 'services.layoutEditor.insertSpace', [
  "services.editorNamespace"
]

moduleInsertSpace.factory 'insertSpace',  ["$timeout", "ns", "$injector", ($timeout, ns, $injector) ->

  Y = undefined

  insertSpace =
    availableForDropFloating: ["text"]
    availableForDragFloating: ["image"]
    isTextBlock: (block) ->
      if block
        block.hasClass(ns.blockTextClass.substr(1)) || block.hasClass(ns.blockHeadline1Class.substr(1)) || block.hasClass(ns.blockHeadline2Class.substr(1)) || block.hasClass(ns.blockHeadline3Class.substr(1))
    firstOrLastBlockInColumn: (element, ip) ->
      blocksBuilder = $injector.get "blocksBuilder"
      isSection = blocksBuilder.isSection $(element._node)
      lastBlock = $(element._node).is($(element._node).parent(ns.colClass).find(ns.blockClass).last())
      firstCol = $(element._node).parents(ns.colClass).index() is 0
      firstBlock = $(element._node).index() is 0
      !isSection && firstCol && (firstBlock || lastBlock && ip.regionEdge is "bottom")
    addInsertSpace: ->
      markerExist = Y.one(".#{ns.insertSpaceClass}")
      if !markerExist
        @insertSpaceNode = Y.Node.create('<div/>')
          .addClass(ns.insertSpaceClass)
          .appendTo ns.tplContainer
      return
    removeInsertSpace: ->
      return
    firstBlock: (element) ->
      lastBlockIndex = element.ancestor(ns.colClass).all(ns.blockClass).size() - 1
      dropTargetIndex = $(element._node).index()
      (0 is dropTargetIndex)
    lastBlock: (element, event = false) ->
      isSelf = element.getStyle("visibility") is "hidden"
      dragElementFromThisCol = element.ancestor(ns.colClass) is @dragNode.ancestor(ns.colClass)
      if event is "drag:drag" and dragElementFromThisCol
        lastBlockIndex = element.ancestor(ns.colClass).all(ns.blockClass).size() - 2
      else
        lastBlockIndex = element.ancestor(ns.colClass).all(ns.blockClass).size() - 1
      dropTargetIndex = $(element._node).index()
      (lastBlockIndex is dropTargetIndex)
    dragShowInsertSpace: ->
      @insertSpaceNode.addClass 'str-im_active' if !@insertSpaceNode.hasClass "str-im_active"
    centerSelf: ->
      nodeWidth = parseInt @dropNode.getStyle("width")
      inCenter = @nearestEdge.distance > (nodeWidth/2*0.4)
      if inCenter && @nearestEdge.isSelf
        @nearestEdge.direction = "center"
    getSizeCol: ->
      parentCol = @dropNode.ancestor(ns.colClass)._node
      {width: parentCol.clientWidth, height: parentCol.clientHeight}
    getColPosition: ->
      @dropNode.ancestor(ns.colClass).getXY()
    inCenterOfBlock: ->
      @insertSpaceNode.setStyles {
        width: @dropNode.getStyle("width")
        height: @dropNode.getStyle("height")
      }
    inTopOfBlock: ->
      firstBlock = @firstBlock @dropNode
      lastBlock = @lastBlock @dropNode, "drag:drag"
      if firstBlock && !@distanceForBlock
        insertSpace.alignInsertSpaceRowOrSection @nearestEdge, "row"
      else
        @insertSpaceNode.setStyles
          height: ns.dragOverLineWidth
          width: @colSize.width
    inLeftOfBlock: ->
      if @distanceForBlock
        dropNodeXY = @dropNode.getXY()
        @insertSpaceNode.setXY dropNodeXY
        @insertSpaceNode.setStyles
          width: ns.dragOverLineWidth
          height: @dropNode._node.clientHeight
      else
        @insertSpaceNode.setStyles
          width: ns.dragOverLineWidth
          height: @colSize.height
        @insertSpaceNode.setXY @getColPosition()
    inRightOfBlock: ->
      if @distanceForBlock
        @insertSpaceNode.setStyles
          width: ns.dragOverLineWidth
          height: @dropNode._node.clientHeight
        dropNodeXY = @dropNode.getXY()
        @insertSpaceNode.setXY [
          @getColPosition()[0]+@colSize.width
          dropNodeXY[1]
        ]
      else
        @insertSpaceNode.setStyles
          width: ns.dragOverLineWidth
          height: @colSize.height
        @insertSpaceNode.setXY [
          @getColPosition()[0]+@colSize.width,
          @getColPosition()[1]
        ]
    inBottomOfBlock: ->
      firstBlock = @firstBlock @dropNode
      lastBlock = @lastBlock @dropNode, "drag:drag"
      dropNodeXY = @dropNode.getXY()
      if lastBlock && !@distanceForBlock
        insertSpace.alignInsertSpaceRowOrSection @nearestEdge, "row"
      else
        @colSize.height = @dropNode._node.clientHeight
        @insertSpaceNode.setStyles
          height: ns.dragOverLineWidth
          width: @colSize.width
        @insertSpaceNode.setXY [
          dropNodeXY[0],
          dropNodeXY[1]+@colSize.height
        ]
    enableForInsert: (fromDragOver) ->
      blocksBuilder = $injector.get "blocksBuilder"
      dragCol = false
      if @dragNode
        dragCol = @dragNode.ancestor(ns.colClass)
      availableSpace = blocksBuilder.getAvailableColSize @dropNode.ancestor(ns.rowClass), dragCol, fromDragOver
      min_size = 1
      if @dragNode and $(@dragNode._node).scope() and $(@dragNode._node).scope().block
        min_size = $(@dragNode._node).scope().block.min_size
      else
        min_size = @dragNode.widget.min_size
      (availableSpace - min_size) >= 0
    beFloating: ->
      noderegion = @nearestEdge.region
      width = noderegion.width / 2
      quadx = @nearestEdge.quad.x
      quady = @nearestEdge.quad.y
      xy = @dropNode.getXY()

      availableCoords = 60
      if noderegion and noderegion.height isnt 0
        height = width * (noderegion.height / noderegion.width)
      else
        height = width * 0.5623
      if @nearestEdge.distance > availableCoords and !@nearestEdge.isSelf
        if quady is "top"
          if quadx is "left"
            @insertSpaceNode.setStyles left:xy[0]
            @dropNode.float = "left"
          if quadx is "right"
            @insertSpaceNode.setStyles left:xy[0]+width
            @dropNode.float = "right"
          if quadx is "right" || quadx is "left"
            @insertSpaceNode.setStyles
              top: @dropNode.getXY()[1]-ns.shiftTop()
              height: height
              width: width
      else
        @dropNode.float = undefined
      return
    regionMarkerSwitcher: ->
      switch @nearestEdge.direction
        when "center"
          @inCenterOfBlock()
        when "top"
          @inTopOfBlock()
        when "left"
          @inLeftOfBlock()
        when "right"
          @inRightOfBlock()
        when "bottom"
          @inBottomOfBlock()
      dragBlockType = @dragNode.widget and @dragNode.widget.type || $(@dragNode._node).scope().block.type
      if @dropNode.widget and @dropNode.widget.type in @availableForDropFloating and dragBlockType in @availableForDragFloating
        @beFloating()
    alignInsertSpaceBlock: (nearestEdge, dragNode) ->
      @dragNode = dragNode
      @nearestEdge = nearestEdge
      @dropNode = nearestEdge.node
      @dragShowInsertSpace()
      @colSize = @getSizeCol()
      @centerSelf()
      dropNodeXY = @dropNode.getXY()
      @insertSpaceNode.setXY dropNodeXY
      @distanceForBlock = @nearestEdge.distance > ns.dragBlockToRowDistance
      @regionMarkerSwitcher()
    alignInsertSpaceRowOrSection: (region, type) ->
      @insertSpaceNode.setStyles
        width: 0
        height: 0
      @insertSpaceNode.addClass 'str-im_active' if !@insertSpaceNode.hasClass "str-im_active"
      dropTarget = region.node
      tagName = dropTarget.get('tagName').toLowerCase()
      lineHeight = ns.dragOverLineWidth
      if type is "row"
        node = if region.node.hasClass("str-row") then region.node else region.node.ancestor(ns.rowClass)
      if type is "section"
        lineHeight += 4
        if region.quad.y is "top" and tagName is "header"
          return false
        if region.quad.y is "bottom" and tagName is "footer"
          return false
        node = if region.node.hasClass("str-section") then region.node else region.node.ancestor(ns.sectionClass)
      dropNodeXY = node.getXY()
      elementWidth =  node._node.clientWidth
      elementHeight =  node._node.clientHeight
      @insertSpaceNode.setXY dropNodeXY
      switch region.quad.y
        when "top"
          @insertSpaceNode.setStyles
            height: lineHeight
            width: elementWidth
        when "bottom"
          @insertSpaceNode.setStyles
            height: lineHeight
            width: elementWidth
          @insertSpaceNode.setXY [
            dropNodeXY[0],
            dropNodeXY[1]+elementHeight
          ]
    positionCorrect: (ip, element) ->
      position = ip.getXY()
      elementPosition = ip.regionNode.getXY()
      top = position[1]+10
      left = position[0]+26
      left -= 26 if @firstOrLastBlockInColumn element, ip
      left -= 26 if elementPosition[0] < 26
      [left, top]
    show: (insertPoint) ->
      pointPosition = @positionCorrect insertPoint, insertPoint.regionNode
      elementWidth = insertPoint.regionNode._node.clientWidth
      @insertSpaceNode.toggleClass 'str-im_active'
      @insertSpaceNode.setXY pointPosition
      @insertSpaceNode.setStyle "width", elementWidth
      return
    hideFull: ->
      @insertSpaceNode.removeClass 'str-im_active'
      @insertSpaceNode.setStyles
        height: 0,
        width: 0
      @insertSpaceNode.setXY [0, 0]
    hide: ->
      @insertSpaceNode.removeClass 'str-im_active'
      @insertSpaceNode.setStyle "height", ns.dragOverLineWidth
      @insertSpaceNode.setXY [0, 0]
    destroy: ->
      @insertSpaceNode.remove()
    init: (y) ->
      Y = y
      @addInsertSpace()

  return insertSpace

]



// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/insertSpace.coffee